<template>
  <v-row no-gutters style="position: relative; height: 100%;">
    <v-col cols="12" style="position: relative;">
      <span v-if="household.user">
         <onboarding-index
             :household="household"
             :user="user"
             @on-debt-updated="updateDebt"
             @on-debt-deleted="deleteDebt"
             @on-intake-updated="updateIntake"
         />
      </span>


<!--      <v-row no-gutters style="height: 100%;">-->
<!--        <v-col-->
<!--          cols="12"-->
<!--        >-->
<!--          <v-row no-gutters class="flex-column" style="height: 100%;">-->

<!--            <v-col v-if="loading" class="text-center pa-6">-->
<!--              <v-progress-circular-->
<!--                :size="40"-->
<!--                :width="7"-->
<!--                color="primary"-->
<!--                indeterminate-->
<!--              ></v-progress-circular>-->
<!--            </v-col>-->
<!--            <v-col v-else>-->
<!--              <v-tabs-items v-model="tab" style="height: 100%;">-->
<!--                <v-tab-item-->
<!--                  value="onboarding"-->
<!--                  transition="fade-up"-->
<!--                  reverse-transition="fade-up"-->
<!--                  style="height: 100%;"-->
<!--                >-->
<!--                  <onboarding-index-->
<!--                    :household="household"-->
<!--                    @on-debt-updated="updateDebt"-->
<!--                    @on-debt-deleted="deleteDebt"-->
<!--                    @on-intake-updated="updateIntake"-->
<!--                  />-->
<!--                </v-tab-item>-->
<!--                <v-tab-item-->
<!--                  value="settings"-->
<!--                  transition="fade-up"-->
<!--                  reverse-transition="fade-up"-->
<!--                  style="height: 100%;"-->
<!--                >-->
<!--                  <settings-->
<!--                    :household="household"-->
<!--                    @on-intake-updated="updateIntake"-->
<!--                  />-->
<!--                </v-tab-item>-->
<!--                <v-tab-item-->
<!--                  value="prd-freedom-accelerator"-->
<!--                  transition="fade-up"-->
<!--                  reverse-transition="fade-up"-->
<!--                  style="height: 100%;"-->
<!--                >-->
<!--                  <freedom-accelerator-index-->
<!--                    :household="household"-->
<!--                    :plan="plan"-->
<!--                    :plans="plans"-->
<!--                    key="prd-fa-index"-->
<!--                    @on-update-intake="updateIntakeSummary"-->
<!--                    @on-policy-updated="updatePolicy"-->
<!--                    @on-debt-updated="updateDebt"-->
<!--                    @on-plan-updated="updatePlan"-->
<!--                    @on-plan-status-updated="updatePlanStatus"-->
<!--                  />-->
<!--                </v-tab-item>-->
<!--                <v-tab-item-->
<!--                  value="debts"-->
<!--                  transition="fade-up"-->
<!--                  reverse-transition="fade-up"-->
<!--                  style="height: 100%;"-->
<!--                >-->
<!--                  <debts-index :household="household" @on-debt-updated="updateDebt" @on-debt-deleted="deleteDebt" @on-plans-altered="onPlansAltered" />-->
<!--                </v-tab-item>-->
<!--                <v-tab-item-->
<!--                  value="policies"-->
<!--                  transition="fade-up"-->
<!--                  reverse-transition="fade-up"-->
<!--                  style="height: 100%;"-->
<!--                >-->
<!--                  <policies-index :household="household" @on-policy-updated="updatePolicy" @on-policy-deleted="deletePolicy" @on-plans-altered="onPlansAltered" />-->
<!--                </v-tab-item>-->
<!--              </v-tabs-items>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--        </v-col>-->
<!--      </v-row>-->
    </v-col>

    <div style="position: absolute; bottom: -15px; left: 5px;">
      <v-btn v-show="showAdvancedButton" color="grey lighten-2" small text @click="advancedSettingsDialog = true"><v-icon small>mdi-information-outline</v-icon></v-btn>
    </div>
  </v-row>
</template>

<script>
import OnboardingIndex from './onboarding/editClient'
// import DebtsIndex from '@/views/households/liabilities/Index'
// import PoliciesIndex from '@/views/households/policies/Index'
// import FreedomAcceleratorIndex from '@/views/households/freedom-accelerator/Index'
// import Settings from '@/views/households/Settings'

export default {
  name: 'HouseholdsView',
  components: {
    OnboardingIndex,
    // DebtsIndex,
    // PoliciesIndex,
    // FreedomAcceleratorIndex,
    // Settings
  },
  data: () => ({

    loading: true,
    tab: null,
    household_id: null,
    user:null,
    household: {},
    refetchMortgageEnhancerPlan: false,
    mortgageEnhancerPlan: null,
    refetchPlan: false,
    plan: null,
    plans: [],
    minPlan: null,
    settingsDialog: false,
    advancedSettingsDialog: false,
    savingHousehold: false,
    newUser: null,
    newUserIncome: null,
    newSpouse: null,
    newSpouseIncome: null,
    newThreshold: null,
    newDesiredMonthlyCap: null,
    newDesiredOutcomes: [null,null,null,null,null],
    newPreparedBy: null,
    newPreparedByEmail: null,
    newPreparedByTitle: null,
    newDebtAlgorithm: 'balance_low_high',
    newAdditionalLoanPrincipal: 0,
    newShowBenefits: true,
    debtAlgorithms: [
      {
        text: 'Lowest Balance First',
        value: 'balance_low_high'
      },
      {
        text: 'Highest Interest Rate First',
        value: 'interest_high_low'
      }
    ],
    expansions: 'user,spouse,debts,debts.amortizationSchedule,policies,plans,encrypted_id,user.agent',

    showAdvancedButton: false
  }),
  watch: {
  },
  mounted() {

    if(this.$route.params.token){
      this.getDataFromApi(this.$route.params.token)
    }
    this.refetchMortgageEnhancerPlan = true

    document.addEventListener('keydown', this.keyCheck)
    document.addEventListener('keyup', this.keyCheck)
  },
  beforeDestroy() {
    document.removeEventListener('keydown',this.keyCheck)
    document.removeEventListener('keyup',this.keyCheck)
  },
  computed: {


    hasAMortgageAndPolicy() {
      if(!this.household || !this.household.debts || !this.household.policies) return false
      let hasMortgage = false
      let hasActivePolicy = false

      for(let i = 0; i < this.household.debts.length; i++) {
        if(this.household.debts[i].type == 'mortgage') {
          hasMortgage = true
          break
        }
      }

      for(let i = 0; i < this.household.policies.length; i++) {
        if(this.household.policies[i].default) {
          hasActivePolicy = true
          break
        }
      }

      return (hasMortgage && hasActivePolicy)
    },
  },
  methods: {

    getDataFromApi(token) {
      this.loading = true;

      this.$http.post('household-customer-data/get-household', {token:token})
        .then(response => {
          // if(response.data.error == 'error_token'){
          //   this.$swal.fire('Error', 'Time limit end');
          //   return;
          // }
          this.plans                        = response.data.plans
          response.data.plans.forEach(p => {
            if(p.default) this.plan = JSON.parse(JSON.stringify(p))
          })
          delete response.data.plans;
          response.data.intake_step = response.data.intake_step > 1 ? response.data.intake_step : 1;
          this.household                    = response.data
          this.household_id                 = response.data.id
          this.user                         = response.data.user
          this.newThreshold                 = response.data.plan_threshold
          this.newDesiredMonthlyCap         = response.data.desired_monthly_cap
          let arr                           = response.data.desired_outcomes.split("\n")
          while(arr.length < 5) {
            arr.push(null)
          }
          this.newDesiredOutcomes           = arr
          this.newPreparedBy                = response.data.prepared_by
          this.newPreparedByTitle           = response.data.prepared_by_title
          this.newPreparedByEmail           = response.data.prepared_by_email
          this.newUser                      = response.data.user
          this.newSpouse                    = response.data.spouse
          this.newUserIncome                = response.data.user_income_monthly
          this.newSpouseIncome              = response.data.spouse_income_monthly
          this.newDebtAlgorithm             = response.data.plan_algorithm
          this.newAdditionalLoanPrincipal   = response.data.plan_addl_policy_replenishment
          // this.newShowBenefits              = (response.data.plan_show_benefits ? true : false)
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'Time limit end')
          // this.$router.go(-1)
        })
        .finally(() => {
          this.loading = false
        })
    },

    saveHousehold() {
      if(!this.newUser || !this.newUser.id) {
        this.$swal.fire('Homeowner Required', 'A Homeowner is required and can not be blank', 'error')
        return
      }
      this.savingHousehold = true

      let uIncome = (this.newUserIncome ? this.newUserIncome : 0)
      let sIncome = (this.newSpouse && this.newSpouse.id ? this.newSpouseIncome : 0)
      if(!sIncome) sIncome = 0

      let desired_outcomes_arr = []
      for(let i = 0; i < this.newDesiredOutcomes.length; i++) {
        if(i > 4) break;
        if(this.newDesiredOutcomes[i]) desired_outcomes_arr.push(this.newDesiredOutcomes[i])
      }

      let data = {
        plan_threshold: this.newThreshold,
        desired_monthly_cap: this.newDesiredMonthlyCap,
        desired_outcomes: desired_outcomes_arr.join("\n"),
        prepared_by: this.newPreparedBy,
        prepared_by_title: this.newPreparedByTitle,
        prepared_by_email: this.newPreparedByEmail,
        spouse_id: (this.newSpouse ? this.newSpouse.id : null),
        spouse_income_monthly: sIncome,
        user_id: this.newUser.id,
        user_income_monthly: uIncome,
        plan_algorithm: (this.newDebtAlgorithm ? this.newDebtAlgorithm : 'balance_low_high'),
        plan_addl_policy_replenishment: (this.newAdditionalLoanPrincipal ? this.newAdditionalLoanPrincipal : 0),
        plan_show_benefits: (this.newShowBenefits ? 1 : 0)
      }
      this.$http.put('households/' + this.householdId + '?expand=' + this.expansions, data)
        .then(response => {
          this.plan                 = JSON.parse(JSON.stringify(response.data.plan))
          delete response.data.plan
          this.household                      = response.data
          this.newThreshold                   = response.data.plan_threshold
          this.newDesiredMonthlyCap           = response.data.desired_monthly_cap
          let arr                             = response.data.desired_outcomes.split("\n")
          while(arr.length < 5) {
            arr.push(null)
          }
          this.newDesiredOutcomes             = arr
          this.newPreparedBy                  = response.data.prepared_by
          this.newPreparedByTitle             = response.data.prepared_by_title
          this.newPreparedByEmail             = response.data.prepared_by_email
          this.settingsDialog                 = false
          this.advancedSettingsDialog         = false
          this.newUser                        = response.data.user
          this.newSpouse                      = response.data.spouse
          this.newUserIncome                  = response.data.user_income_monthly
          this.newSpouseIncome                = response.data.spouse_income_monthly
          this.newDebtAlgorithm               = response.data.plan_algorithm
          this.plan_addl_policy_replenishment = response.data.plan_additional_principal
          this.newShowBenefits                = (response.data.plan_show_benefits ? true : false)
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'There wasn an error updating the household', 'error')
        })
        .finally(() => {
          this.savingHousehold = false
        })
    },
    updateDebt ( debt ) {
      //this.refetchPlan = true
      this.refetchMortgageEnhancerPlan = true
      let found = null
      for(let i = 0; i < this.household.debts.length; i++) {
        if(this.household.debts[i].id == debt.id) {
          found = i;
          break;
        }
      }

      if(found !== null) {
        this.$set(this.household.debts, found, debt)
      } else {
        this.household.debts.push(debt);
      }
    },
    updatePolicy ( policy ) {
      //this.refetchPlan = true
      this.refetchMortgageEnhancerPlan = true
      let found = null
      for(let i = 0; i < this.household.policies.length; i++) {
        if(this.household.policies[i].id == policy.id) {
          found = i;
          break;
        }
      }

      if(found !== null) {
        this.$set(this.household.policies, found, policy)
      } else {
        this.household.policies.push(policy);
      }
    },
    deleteDebt (debt) {

      console.log(debt )
      this.$swal.fire({
        title: 'Are you sure?',
        html: 'Please confirm that you want to remove<br><b>' + debt.name + ' - $' + parseFloat(debt.balance).toLocaleString(undefined, {maximumFractionDigits:2}) + '</b>',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        preConfirm: () => {
          this.$swal.update({showCancelButton: false});
          this.$http.post('household-customer-data/delete-debt', {debt_id:debt.id})
            .finally(() => {
              for(let i = 0; i < this.household.debts.length; i++) {
                if(this.household.debts[i].id == debt.id) {
                  this.household.debts.splice(i, 1)
                  break
                }
              }
              return {}
            })
        }
      })
    },
    deletePolicy (policy) {
      this.$swal.fire({
        title: 'Are you sure?',
        html: 'Please confirm that you want to remove<br><b>' + policy.name + '</b>',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        preConfirm: () => {
          this.$swal.update({showCancelButton: false});
          this.$http.delete('policies/' + policy.id)
            .finally(() => {
              for(let i = 0; i < this.household.policies.length; i++) {
                if(this.household.policies[i].id == policy.id) {
                  this.household.policies.splice(i, 1)
                  break
                }
              }
              return {}
            })
        }
      })
    },

    keyCheck (e) {
      if(e.shiftKey) {
        this.showAdvancedButton = true
      } else {
        this.showAdvancedButton = false
      }
    },

    updateIntake(data) {
      this.$set(this.household, 'user_id', data.user_id)
      this.$set(this.household, 'user', data.user)
      this.$set(this.household, 'spouse_id', data.spouse_id)
      this.$set(this.household, 'spouse', data.spouse)
      this.$set(this.household, 'intake', data.intake)
      this.$set(this.household, 'intake_step', data.intake_step ?? 1)

      this.$set(this.household, 'prepared_by', data.prepared_by)
      this.$set(this.household, 'prepared_by_title', data.prepared_by_title)
      this.$set(this.household, 'prepared_by_email', data.prepared_by_email)
      this.plans = data.plans
      data.plans.forEach(p => {
        if(p.default) this.plan = JSON.parse(JSON.stringify(p))
      })
    },
    updateIntakeSummary(data) {
      this.$set(this.household, 'intake', data.intake)
      this.$set(this.household, 'desired_monthly_cap', data.desired_monthly_cap)
    },
    updatePlan(plan) {
      let exists = null
      for(let i = 0; i < this.plans.length; i++) {
        if(this.plans[i].id == plan.id) {
          exists = i
          break
        }
      }

      if(exists !== null) {
        if(plan.default && !this.plans[exists].default) this.clearActiveStatusOnPlans()
        this.$set(this.plans, exists, plan)
      } else {
        if(plan.default) this.clearActiveStatusOnPlans()
        if(plan.status == 'ACTIVE' && plan.previous_id) {
          if(this.plans.length == 1) {
            this.$set(this.plans[0], 'status','ORIGINAL')
          } else {
            for(let i = 0; i < this.plans.length; i++) {
              if(this.plans[i].id == plan.previous_id) this.$set(this.plans[i], 'status', 'REPLACED')
            }
          }
        }
        this.plans.push(plan)
      }

      this.plan = JSON.parse(JSON.stringify(plan))
    },
    updatePlanStatus(plan) {
      let exists = null
      for(let i = 0; i < this.plans.length; i++) {
        if(this.plans[i].id == plan.id) {
          exists = i
          break
        }
      }
      if(exists !== null) this.$set(this.plans[exists],'status', plan.status)
      if(this.plan.id == plan.id) this.$set(this.plan, 'status', plan.status)
    },
    clearActiveStatusOnPlans() {
      this.plans.forEach((p,i) => {
        this.$set(this.plans[i], 'default', 0)
      })
    },
    onPlansAltered() {
      this.getDataFromApi(this.$route.params.token)
    }
  }
}
</script>

<style lang="scss" scoped>
  .infoTable {
    tbody {
      tr {
        td {
          &:first-child {
            width: 130px;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  .desiredOutcomesTextarea {
    textarea {
      resize: none;
      margin-top: 2px !important;
    }
  }

  .householdTab {
    width: 120px;
    position: relative;
    .householdTabText {
      position: absolute;
      top: 70px;
      height: 30px;
      display: flex;
      align-items: center;
    }
    .householdTabIcon {
      position: absolute;
      top: 20px;
    }
  }
  .householdTabButton {
    width: 120px !important;
    height: 120px !important;
    i {
      transform: translateY(-20px);
    }
  }
</style>